var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { show: _vm.show }, attrs: { id: "loading" } }, [
    _c("div", { staticClass: "pic" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }